import { hash } from 'rsvp';
import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import ActionBookingsRepliesNewController from 'uplisting-frontend/pods/action/bookings/replies/new/controller';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';
import { getParentRouteRecordKey } from 'uplisting-frontend/utils/rhs/helpers';

export default abstract class SidebarBookingsRepliesNewRoute extends BaseRoute {
  @service('repositories/saved-reply')
  savedReplyRepository!: Services['repositories/saved-reply'];

  abstract parentRoute: string;

  model() {
    const record = this.modelFor(this.parentRoute) as RhsRecord;

    return hash({
      [getParentRouteRecordKey(this.parentRoute)]: record,
      property: record.property.reload(),
      savedReplies: this.savedReplyRepository.findAll({
        include: 'custom-message-tags',
      }),
    });
  }

  setupController(
    controller: ActionBookingsRepliesNewController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);
  }
}
